import React, { useState } from 'react'
import { unwrap } from 'api/call'
import {
  putFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerId,
  type PlayerMergeSearch,
} from 'api/generated'
import { Header } from 'components/layout/header'
import { Main } from 'components/layout/main'
import { Search } from 'components/search'
import { Button } from 'components/ui/button'
import { toast } from 'sonner'
import SearchablePlayer from 'ui/components/SearchablePlayer'

const PlayersMerge: React.FC = () => {
  const [sourcePlayer, setSourcePlayer] = useState<PlayerMergeSearch | null>(
    null
  )
  const [destinationPlayer, setDestinationPlayer] =
    useState<PlayerMergeSearch | null>(null)

  const handleMerge = () => {
    if (
      sourcePlayer &&
      destinationPlayer &&
      sourcePlayer.id !== destinationPlayer.id
    ) {
      unwrap(
        putFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerId({
          path: {
            source_player_id: sourcePlayer.id,
            destination_player_id: destinationPlayer.id,
          },
        })
      )
        .then(() => toast.success('Merge effettuato con successo'))
        .catch(() =>
          toast.error(
            'Si è verificato un errore durante il merge dei giocatori'
          )
        )
    }
  }

  return (
    <>
      {/* ===== Top Heading ===== */}
      <Header>
        <div className='ml-auto flex items-center space-x-4'>
          <Search />
        </div>
      </Header>

      {/* ===== Main ===== */}
      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>
              Merge Giocatori
            </h2>
            <p className='text-muted-foreground'>
              Unisci 2 profili di giocatori
            </p>
          </div>
        </div>
        <div className='-mx-4 mt-5 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-y-0 lg:space-x-12'>
          <div className='flex flex-col gap-5'>
            <SearchablePlayer
              player={sourcePlayer}
              onChangePlayerHandler={setSourcePlayer}
              label='Giocatore sorgente'
            />
            <SearchablePlayer
              player={destinationPlayer}
              onChangePlayerHandler={setDestinationPlayer}
              label='Giocatore di destinazione'
            />
            <div className='mt-5'>
              <Button
                onClick={handleMerge}
                disabled={
                  !sourcePlayer ||
                  !destinationPlayer ||
                  (sourcePlayer &&
                    destinationPlayer &&
                    sourcePlayer.id === destinationPlayer.id)
                }
              >
                Merge
              </Button>
            </div>
          </div>
        </div>
      </Main>
    </>
  )
}

export default PlayersMerge
